import { changeItemInObjectsArray } from 'utils/globals/app';
import {
  getStaffAction,
  updateStaffAction,
  getStaffSuggestionsAction,
  addStaffAction,
  deleteStaffAction,
  getStaffProfessionsAction,
} from './actions';
import { listReducer, namedListParams } from '../../utils/crudUtils';

export const key = 'EditStaff';

export const initialState = {
  staff: namedListParams('staff'),
  staffSuggestions: namedListParams('staffSuggestions'),
  staffUpdating: false,
  professions: namedListParams('staffProfessions'),
};

const editStaffReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case getStaffAction.FAILURE:
    case getStaffAction.TRIGGER:
    case getStaffAction.SUCCESS:
      return listReducer(state, type, payload, initialState.staff.listName);

    case updateStaffAction.TRIGGER:
      return { ...state, staffUpdating: true };
    case updateStaffAction.SUCCESS:
      return {
        ...state,
        staffUpdating: false,
        staff: { ...state.staff, data: changeItemInObjectsArray(state?.staff?.data, payload?.entity) },
      };
    case updateStaffAction.FAILURE:
      return { ...state, staffUpdating: false };

    case addStaffAction.SUCCESS: {
      return {
        ...state,
        [initialState.staff.listName]: {
          ...state[initialState.staff.listName],
          data: [payload.entity, ...state.staff.data],
        },
      };
    }

    case getStaffSuggestionsAction.TRIGGER:
    case getStaffSuggestionsAction.SUCCESS:
    case getStaffSuggestionsAction.FAILURE:
      return listReducer(state, type, payload, initialState.staffSuggestions.listName);

    case deleteStaffAction.TRIGGER:
      return { ...state, staffUpdating: true };
    case deleteStaffAction.SUCCESS: {
      return {
        ...state,
        [initialState.staff.listName]: {
          ...state.staff,
          data: state[initialState.staff.listName]?.data.filter(d => d?.id !== payload?.id),
        },
        staffUpdating: false,
      };
    }
    case deleteStaffAction.FAILURE:
      return { ...state, staffUpdating: false };

    case getStaffProfessionsAction.TRIGGER:
    case getStaffProfessionsAction.SUCCESS:
    case getStaffProfessionsAction.FAILURE:
      return listReducer(state, type, payload, initialState.professions.listName);

    default:
      return state;
  }
};

export default editStaffReducer;
